import { Stack, Typography } from '@mui/material'
import { Form } from 'react-hook-form'
import { SliderWithButtons } from '~/@ui/slider/SliderWithButtons/SliderWithButtons'
import { TransactionsInfo } from './TransactionsInfo/TransactionsInfo'
import { QRCode } from './QRCode/QRCode'
import { Header } from '~/@ui/header/Header'

type Props = {
  variableSymbol: any
  control: any
  amount: any
  className?: string
}

export const AddFunds = ({
  variableSymbol,
  control,
  amount,
  className = '',
}: Props) => {
  const iban = 'SK94 7500 0000 0040 3480 9287'

  return (
    <Stack className={`px-6 pt-6 bg-zWhite100 rounded-t-3xl ${className}`}>
      <Header
        title="Previesť prostriedky"
        text="Prevod môže trvať 24 hodín počas pracovných dní. Po pripísaní peňazí do Mojej peňaženky môžete investovať"
      />

      <Stack className="mt-10">
        <Form control={control}>
          <Stack className="gap-5 px-4 pt-4 pb-3 bg-zGrey200 rounded-4d">
            <Typography className="text-base font-semibold text-zBlack200">
              Čiastka, ktorú chcete vložiť
            </Typography>
            <SliderWithButtons
              darkTheme
              className="gap-2"
              name={'amount'}
              suffix="€"
              control={control}
              min={50}
              max={10000}
              step={50}
            />
          </Stack>
        </Form>
        <Typography className="text-base mt-8 font-semibold text-zBlack200">
          Nakoľko ide o prototypové riešenie, realizácia platieb a odosielanie finančných prostriedkov nie sú možné.
        </Typography>
        {/* <TransactionsInfo variableSymbol={variableSymbol} iban={iban} /> */}
      </Stack>

      {/* <Stack className="h-[200px] items-center p-5 mt-4 bg-zGrey200 rounded-4d">
        {!variableSymbol && 'Načitávam...'}
        {variableSymbol && (
          <QRCode
            amount={amount}
            variableSymbol={variableSymbol}
            iban={iban}
            swift=""
            userName=""
            companyName=""
          />
        )}
      </Stack> */}
    </Stack>
  )
}
